import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createAction, createReducer, on, createSelector, props, createActionGroup, createFeature, emptyProps } from '@ngrx/store';

import { SearchParams, SearchSortKey } from '../../../globalTypes/search.types'

export interface SearchState {
  params: SearchParams;
  limit: number;
  offset: number;
  page: number;
}

export const initialState: SearchState = {
  params: {
    sortDir: "DESC",
    sortKey: "createdAt",
  },
  limit: 20,
  offset: 0,
  page: 0,
}

// Actions
export const searchActions = createActionGroup({
  source: 'search',
  events: {
    'Add Search': (search: SearchParams) => ({ search }),
    'Adjust Sort': (sortKey: SearchSortKey, sortDir: 'ASC' | 'DESC') => ({ sortKey, sortDir}),
    'Add Min Price': (priceMin: number | undefined) => ({ priceMin }),
    'Add Max Price': (priceMax: number | undefined) => ({ priceMax }),
    'Contains': (contains: string) => ({contains}),
    'Toggle Favorited': emptyProps(),
    'Toggle Only Listings From LocationId': ( locationId: string | undefined) => ({locationId}),
    'Set Category': (categoryIds: number[]) => ({ categoryIds}),
    'Clear Search': emptyProps(),
    'Increase Load Amount': emptyProps(),
  },
});

const freshSearch = { offset: 0, page: 0}

// Reducer
export const searchReducer = createReducer(
  initialState,
  on(searchActions.addSearch, (state, { search }) => ({ ...state, params: search})),
  on(searchActions.adjustSort, (state, { sortKey, sortDir}) => ({ ...state, ...freshSearch, params: { ...state.params, sortDir, sortKey}})),
  on(searchActions.addMinPrice, (state, { priceMin}) => ({ ...state, ...freshSearch, params: { ...state.params, priceMin}})),
  on(searchActions.addMaxPrice, (state, { priceMax}) => ({ ...state, ...freshSearch, params: { ...state.params, priceMax}})),
  on(searchActions.contains, (state, {contains}) => ({ ...state, params: { ...state.params, contains}})),
  on(searchActions.toggleFavorited, (state) => ({ ...state, ...freshSearch, params: { ...state.params, onlyFavorited: !state.params.onlyFavorited}})),
  on(searchActions.toggleOnlyListingsFromLocationId, (state, {locationId}) => ({ ...state, ...freshSearch, params: { ...state.params, onlyListingsFromLocationId: !!state.params.onlyListingsFromLocationId ? undefined : locationId}})),
  on(searchActions.setCategory, (state, { categoryIds}) => ({ ...state, ...freshSearch, params: { ...state.params, categoryIds}})),
  on(searchActions.increaseLoadAmount, (state) => ({ ...state, page: state.page + 1, offset: state.limit * (state.page + 1) })),
  on(searchActions.clearSearch, (state) => ({ ...state, params: initialState.params}))
);


export const searchFeature = createFeature({
  name: 'search',
  reducer: searchReducer,
  extraSelectors: ({ selectLimit, selectOffset, selectPage }) => ({
    selectPageInfo: createSelector( selectLimit, selectOffset, selectPage, (limit, offset, page) => ({limit, offset, page}))
  }),
})